import styled from "styled-components";

export const OptinButtonContainer = styled.div`
  /* stylelint-disable media-feature-range-notation */
  @media only screen and (max-width: 599px) {
    [data-qa-label="promosBodyContentWrapper"] &.promosOptInButton {
      button,
      a {
        display: none;
      }
    }
  }

  @media only screen and (min-width: 689px) {
    &.promosOptInButton {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin: 24px 0;
    }
  }
`;
